import initState from '../data/initialState';
import * as types from '../actions/acttionsTypes';

 export function carouselReducer(state=initState.carousel,action){
    switch(action.type){
        case types.REPLACE_CAROUSEL_DATA :
        let i = action.index;
        return [
            ...state.slice(0,i), // before the one we are updating
           // {...state[i], startClass:state[i].startClass==="animated fadeInUp"?"animated fadeInDown":state[i].startClass==="animated fadeIn"?"animated fadeInDown" :"animated fadeIn"},
            {...state[i],
                startClass:state[i]
                .startClass===state[i]
                .classes[0]?
                state[i].classes[1]:
                state[i].classes[0]
            },
            ...state.slice(i + 1) // after the one we are updating
        ];

        default :
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/carouselReducer.js